<p-dialog [(visible)]="showDialog" [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="hideTheDialog()" [position]="'bottom'" [style]="{ 'min-width': '65vw', 'max-width': '90vw'}">

    <ng-template pTemplate="header">
      @if (dialogContent === 'selectEntryType') {
        <div style="width: 100%;" class="d-flex justify-content-start">
          <h5>{{'integration-apps-instance-provisioning-dialog_select_entry_type_header' | i18next }}</h5>
        </div>
      } @else if (dialogContent === 'fillForm') {
        <div style="width: 100%;" class="d-flex justify-content-center">
          @if (entryToEdit) {
            <h3>{{'integration-apps-instance-provisioning-dialog_edit_entry_header' | i18next }}</h3>
          } @else {
            <h3>{{'integration-apps-instance-provisioning-dialog_create_entry_header' | i18next }}</h3>
          }
        </div>
      }
    </ng-template> 

    @if (dialogContent === 'selectEntryType') {
      <hr class="pt-0 mt-0">
      <div class="instance-provisioning-types">
        @for (item of provisioningTypes; track $index) {
          <app-integration-apps-instance-provisioning-type-card
            [entryType]="item" (onTypeSelected)="selectEntryForm($event)">
          </app-integration-apps-instance-provisioning-type-card>
        }
      </div>
    } @else if (dialogContent === 'fillForm') {
      @if (currentFormType === 'label') {
        <app-instance-provisioning-label-form
          [labelData]="currentLabelEntry"
          (formDataChange)="formDataChanged($event)"
          (formValidityChange)="formValidityChanged($event)">
        </app-instance-provisioning-label-form>
      }

      <div style="height: 50px;"></div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-link mr-2" (click)="hideTheDialog()">{{ 'app_cancel' | i18next }}</button>
        <button class="btn btn-outline-primary" type="button" [disabled]="!canSubmit" (click)="emitData()">{{ (entryToEdit 
          ? 'integration-apps-instance-provisioning-dialog_btn_save_changes'
          : 'integration-apps-instance-provisioning-dialog_btn_add') | i18next }}</button>
      </div>
    }
</p-dialog>